<template>
  <div v-if="product">
    <ul
      class="widget-dollar-handles dollar-handles"
      v-for="donationtype in product.donationtypes"
      v-show="type == donationtype"
    >

     <!-- -->
      <li :for="'handle-' + donationtype + '-' + index.amount"  v-for="index in product.dollarhandles[donationtype]" >
        <div class="inner">
          <div class="img">
            <span :style="'background-image: url('+ index.img +')'"></span>
            <div class="handle-container">
              <label>

                <input
                  :disabled="(formWizardCurrentStep != 0)"
                  type="radio"
                  v-model="dollarhandle"
                  :name="'handle-widget-' + donationtype"
                  :value="index.amount"
                  :id="'handle-widget-' + donationtype + '-' + index.amount"
                />

            

                <span class="amount" :class="{'has-cents': !(index.amount.indexOf('.00') >= 0)}">
                  <span>${{ (index.amount.indexOf('.00') >= 0) ? index.amount.slice(0,-3) : index.amount}}</span>
                </span>
                
                <span class="handle"></span>

                <span class="svg-circle">
                  <svg style="width: 100%; height: 100%;">
                    <circle cx="50%" cy="50%" r="40%" stroke-width="3" />
                  </svg>
                </span>
              </label>
            </div>
          </div>
          <div class="desc">
            <div class="desc-inner">
              <h5>{{ index.text }}</h5>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>


<script>
export default {
  name: "DollarHandleWidget",
  data() {
    return {
      //type: "Single"
    };
  },
  computed: {
    formWizardCurrentStep() {
      return this.$store.getters.donation.formWizardCurrentStep;
    },
    dollarhandle: {
      get() {
        return this.$store.getters.donation.dollarhandle;
      },
      set(value) {
        console.log('Widget::dollarhandle::setter', value);
        this.amount = value == "custom" ? null : value;
        this.$store.commit("updateDonation", { field: "dollarhandle", value });
      }
    },
    type: {
      get() {
        return this.$store.getters.donation.type;
      },
      set(value) {
        this.$store.commit("updateDonation", { field: "type", value });
      }
    },
    amount: {
      get() {
        return this.$store.getters.donation.amount;
      },
      set(value) {
        console.log('Widget::amout::setter', value);
        this.$store.commit("updateDonation", { field: "amount", value });
      }
    },
    product() {
      return this.$store.getters.product;
    }
  },
  props: {
    productId: {
      // Attribute for the productID
      type: String,
      required: true
    },
    productVersion: {
      // Attribute for the version of the product
      type: String
    }
  }
};
</script>


// WEBPACK FOOTER //
// DollarHandleWidget.vue?70c3f2a8